<script>
    import { onMount } from "svelte";
    import * as d3 from "d3";

    export let competitor_keywords_count = [];
    let vennContainerEl = null;
    let vennChartEl = null;
    let vennLegendEl = null;

    const create_venn_diagram = function (target, legend_target, { data }) {
        var chart = venn.VennDiagram();

        // Extract unique sets and calculate their counts
        const setCounts = data.reduce((carry, item) => {
            for (var i = 0; i < item.sets.length; i++) {
                var comp = item.sets[i];
                if (carry[comp] == null) carry[comp] = item.size;
                else carry[comp] += item.size;
            }
            return carry;
        }, {});
        const uniqueSets = Object.keys(setCounts);

        // Create a legend container
        const legendContainer = d3.select(legend_target).append("div").attr("class", "legend");

        // Create a color mapping for consistent colors
        const colorMapping = {};
        uniqueSets.forEach((set, index) => {
            colorMapping[set] = d3.schemeCategory10[index % 10];
        });

        // Add legend items
        uniqueSets.forEach((set, index) => {
            const legendItem = legendContainer
                .append("div")
                .attr("class", "legend-item")
                .style("display", "flex")
                .style("align-items", "center")
                .style("margin-bottom", "5px");

            // Add a color box
            legendItem
                .append("div")
                .attr("class", "legend-color")
                .style("width", "15px")
                .style("height", "15px")
                .style("margin-right", "10px")
                .style("border-radius", "5px")
                .style("background-color", d3.schemeCategory10[index % 10]); // Use D3's color scheme

            // Add the label with the count
            legendItem.append("span").text(`${set} (${setCounts[set]})`);
        });

        // Render the Venn diagram
        d3.select(target).datum(data).call(chart);

        // Style the Venn diagram circles
        d3.selectAll(".venn-circle")
            .each(function (d, i) {
                // Assign the color based on the set
                const setName = d.sets[0]; // Assuming each circle corresponds to a single set
                const color = colorMapping[setName] || "#ccc";
                d3.select(this).select("path").style("fill", color);
                d3.select(this).select("path").style("stroke", "#FFF").style("stroke-width", "2px");
                // Hide text
                d3.select(this).select("text").style("opacity", "0").style("fill", color).style("cursor", "pointer");
            })
            .on("mouseover", function (d, i) {
                var node = d3.select(this).transition();
                node.select("text").style("opacity", "1").style("font-weight", "100").style("font-size", "36px");
            })
            .on("mouseout", function (d, i) {
                var node = d3.select(this).transition();
                node.select("text").style("opacity", "0").style("font-weight", "100").style("font-size", "24px");
            });
    };

    onMount(() => {
        create_venn_diagram(vennChartEl, vennLegendEl, {
            data: competitor_keywords_count,
        });
    });
</script>

<div
    bind:this={vennContainerEl}
    id="venn-container"
    class="venn-container d-flex align-items-center justify-content-center mb-3 flex-wrap"
>
    <div bind:this={vennChartEl} id="venn-chart" class="text-center mb-3"></div>
    <div bind:this={vennLegendEl} id="venn-legend"></div>
</div>

<style>
    #venn-chart {
        transform: scale(0.75);
    }
    @media screen and (min-width: 576px) {
        #venn-chart {
            transform: scale(1);
        }
    }
</style>